
export const POPUP_Z_INDEX = 100
export const SEARCH_BAR_WIDTH = '360px' // see index.css
export const BORDER_RADIUS_FOR_COMPONENTS = '3px'

// Events used in ROM
export const EVENT_TYPES = {
  STATS: {
    LOCATION_CHANGED: 'LOCATION_CHANGED'
  }
}

export const ACS_DATA_NAME_ACCESSOR = "display_name"
export const ACS_DATA_NAME_ACCESSOR_IN_TRACT_DATA = "co_namelsad"
export const FID_COLUMN = "fid"
export const COUNTY_LAT_LON_FIELDS = {lat: "lat", lon: "lon"}
export const GEO_ID_ACCESSOR = "geoid"
export const UNIQUE_ID_FOR_ATTR_DATA = GEO_ID_ACCESSOR
export const STATE_NAME_ACCESSOR = "st_name"
export const NATIONAL_KEY = "NATIONAL"
export const COUNTY_ZOOM_TO_LEVEL = 8
export const STATE_ZOOM_TO_LEVEL = 5
export const MAP_PAN_TRANSITION_DURATION = 4000

export const NECESSARY_FIELDS_PLACEHOLDER = '{NECESSARY ACS FIELDS}'

// Lookup table:
export const BLOCK_FIPS_TO_GEO_ID_LOOKUP_TABLE = 'bl_geoid_lookup'
export const BLOCKS_FIPS_FIELD = 'geoid_bl'
export const LOOKUP_TABLE_FIELDS = {
	cartodb_id: 'cartodb_id',
	censusBlockFIPSCode: 'geoid_bl',
	countySubdivisionCode: 'geoid_cs',
	placeCode: 'geoid_pl',
}

export const MISC_ATTR_FIELDS = {
	image: 'image',
}

export const FILTER_TYPE = {
  NUMERIC: 'NUMERIC',
  CATEGORICAL: 'CATEGORICAL'
}

export const MAPBOX_SATELLITE_LAYER_ID = 'mapbox-satellite'
export const STATE_MASK_ID = 'state_pg'
export const ALL_RURAL_DEFINITIONS_LAYER = 'rural_definitions_all'
export const RURAL_DEFINITION_LAYER_ID_PREFIX = 'rural_by_state'
export const STATE_MASK_STATE_COLUMN_NAME = 'name'

export const BASE_MAP_LAYERS = {
  BASIC: 'BASIC_MAPBOX_BASE_LAYERS',
  DETAILED: 'DETAILED_MAPBOX_BASE_LAYERS',
  SATELLITE: 'SATELLITE_MAPBOX_BASE_LAYERS'
}

// header options, maps to the reference in yaml storymap
export const STORY_HEADER_OPTIONS = {
	LOCATION: 'LOCATION', // default, current location
	SCENE_TITLE: 'SCENE_TITLE' // title of the scene
}

export const GEOGRAPHY_OPTIONS = {
  county: {geography: 'county', cartoLayerId: 'attr_county',},
  place: {geography: 'census place', cartoLayerId: 'attr_place',},
  tract: {geography: 'tract', cartoLayerId: 'attr_tract',},
	countySubdivision: {geography: 'county subdivision', cartoLayerId: 'attr_cousub',},
}

export const ACS_LAYER_IDS_WHICH_HAVE_WIKI_LINKS = ['attr_county', 'attr_place']

export const FILTER_OPTIONS_FOR_EACH_RURAL_DEFINITION = {
  rural_cmsrhc: ['NO', 'YES'],
  rural_cbsa: [
    'Metro area',
    'Micro area',
    'Non-metropolitan'
  ],
  rural_uc: [
    'Non-urban',
    'Urban Cluster',
    'Urbanized Area',
  ],
  rural_ruca: [
    '1.0 = Metropolitan area core: primary flow within an Urbanized Area (UA)',
    '1.1 = Metropolitan area core: primary flow within an Urbanized Area (UA)',
    '2.0 = Metropolitan area high commuting: primary flow 30% or more to a UA',
    '2.1 = Metropolitan area high commuting: primary flow 30% or more to a UA',
    '3.0 = Metropolitan area low commuting: primary flow 10% to 30% to a UA',
    '4.0 = Micropolitan area core: primary flow within an Urban Cluster (UC) of 10,000 through 49,999 (large UC)',
    '4.1 = Micropolitan area core: primary flow within an Urban Cluster (UC) of 10,000 through 49,999 (large UC)',
    '5.0 = Micropolitan high commuting: primary flow 30% or more to a large UC',
    '5.1 = Micropolitan high commuting: primary flow 30% or more to a large UC',
    '6.0 = Micropolitan low commuting: primary flow 10% to 30% to a large UC',
    '7.0 = Small town core: primary flow within an Urban Cluster of 2,500 through 9,999 (small UC)',
    '7.1 = Small town core: primary flow within an Urban Cluster of 2,500 through 9,999 (small UC)',
    '7.2 = Small town core: primary flow within an Urban Cluster of 2,500 through 9,999 (small UC)',
    '8.0 = Small town high commuting: primary flow 30% or more to a small UC',
    '8.1 = Small town high commuting: primary flow 30% or more to a small UC',
    '8.2 = Small town high commuting: primary flow 30% or more to a small UC',
    '9.0 = Small town low commuting: primary flow 10% through 29% to a small UC',
    '10.0 = Rural areas: primary flow to a tract outside a UA or UC (including self)',
    '10.1 = Rural areas: primary flow to a tract outside a UA or UC (including self)',
    '10.2 = Rural areas: primary flow to a tract outside a UA or UC (including self)',
    '10.3 = Rural areas: primary flow to a tract outside a UA or UC (including self)',
    '99.0 = NA',
    'NA = NA',
  ],
}

// legend types
export const LEGEND_TYPE = {
  BINS: '1',
  SOLID: '2',
  ICON: '3',
  ICON_SERIES: '4'
}

export const LEGEND_ICON_SERIES_COUNT = 3

// manually defining this layer to be on top atm
export const TOP_LAYER_OF_BASEMAP = 'poi-label'

export const DELAY_FOR_TOOLTIP_TO_SHOW = 0.8 // seconds

// Map

export const MAP_DEFAULT_SETTINGS = {
  dragPan: true,
  dragRotate: false,
  scrollZoom: true,
  touchZoom: false,
  touchRotate: false,
  keyboard: false,
  doubleClickZoom: true,
  minZoom: 3,
  maxZoom: 24, // Note: this IS the maximum possible zoom
  minPitch: 0,
  maxPitch: 70,
}

export const coriLink = "https://ruralopportunitymap.us/" // link for the top right logo
